import React from 'react';
import { getConfiguration } from '../utils';
import { SeoContext } from './SeoContextProvider';
import { useHandleSeoHtml, useHandleSeoMetas } from './seoUtils';


function SeoMetaTags(props) {
    const cfgSeo = getConfiguration().seo;
    const seoContext = React.useContext(SeoContext);
    useHandleSeoMetas(seoContext.pathname,seoContext.location,'seo-main-container');

    return (
        <></>
    );
}

export default SeoMetaTags;